import React from 'react';
import StageSummary from './StageSummary';
import { Statistics } from './Home';
import { CategoryLink } from './categoryLink';
import {
  StageStatisticsStatus,
  StatisticValue,
  studiesNoun,
} from './stageStatistics';

export type ExtractionProps = {
  reviewerName: string;
  stats: Statistics;
  status: StageStatisticsStatus;
  isOpen: boolean;
};

const Extraction = ({
  reviewerName,
  stats,
  status,
  isOpen,
}: ExtractionProps) => {
  const studyCategoryCount = (
    <>
      <StatisticValue status={status.counters} value={stats?.available} />{' '}
      {studiesNoun(status.counters, stats?.available)} to extract
    </>
  );
  const secondaryContent = (
    <>
      <StatisticValue status={status.counters} value={stats.complete} />{' '}
      extracted
    </>
  );

  return (
    <StageSummary
      isOpen={isOpen}
      stage="included"
      title="Extraction"
      secondaryContent={secondaryContent}
      secondaryLink={CategoryLink('included', 'complete')}
      studyCategoryCount={studyCategoryCount}
      studyCategoryLink={CategoryLink('included')}
      reviewerName={reviewerName}
      stats={stats}
      status={status}
    />
  );
};

export default Extraction;
